// extracted by mini-css-extract-plugin
module.exports = {"title":"accordionCarousel_title__xtHK0"};